/*
 * ॐ नमः शिवाय
 * ಓಂ ನಮಃ ಶಿವಾಯ
 * ఓం నమః శివాయ
 * ஓம் நம சிவாய
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms 
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this 
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and 
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

/**
 * DashboardRedirect
 * -----------------
 * The old table-based Dashboard (/dashboard) is retired — its route is
 * commented out in App.js. Several places still send people to /dashboard
 * (sign-in's default destination, the SSO callback, postLogin, the home page
 * hero button, Banner), and old bookmarks exist, so this answers every
 * /dashboard/* URL instead of letting it fall through to the 404 page:
 *
 *   organizers → /organizer
 *   everyone else → the /feed page that replaces the one they asked for
 *                   (feedRoutes.dashboardToFeed: profile → /feed/profile, …)
 *
 * Router `state` is forwarded, so a notification's highlightId survives.
 */

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { retrieve } from '../../utils/storage_helper';
import { isOrganizerAdmin } from '../../utils/roles';
import { dashboardToFeed } from '../../pages/feed/feedRoutes';

export default function DashboardRedirect() {
  const location = useLocation();
  const target = isOrganizerAdmin(retrieve('userData'))
    ? '/organizer/events'
    : dashboardToFeed(location.pathname, location.search);
  return <Navigate to={target} replace state={location.state} />;
}
